import React from 'react';
import { MDBDataTable } from 'mdbreact';
import { Link } from "react-router-dom";
// reactstrap components
import {
    Card,
    CardHeader,
    NavItem,
    NavLink,
    Nav,
    Row
} from "reactstrap";
export default function UserTable(props) {
    const { data, url, title } = props
    return (
        <>
            <Card className="card_border w-100">
                <CardHeader className="border-0 pt-0">
                    <Row className="align-items-center mobile_sec_col">
                        <div className="col">
                            <h2 className="mb-0">{title}</h2>
                        </div>
                        <div className="col">
                            <Nav className="justify-content-end" pills>
                                <NavItem>
                                    <NavLink to={url} tag={Link} className="btn btn-primary">Add User</NavLink>
                                </NavItem>
                            </Nav>
                        </div>
                    </Row>
                </CardHeader>
                <div className="table-responsive">
                    <MDBDataTable responsive striped bordered hover data={data} />
                </div>
            </Card>
        </>
    )
}